import IcoAddPlus from './IcoAddPlus';
import IcoAlignLeft from './IcoAlignLeft';
import IcoArrowDown from './IcoArrowDown';
import IcoArrowLeft from './IcoArrowLeft';
import IcoArrowRight from './IcoArrowRight';
import IcoArrowUp from './IcoArrowUp';
import IcoAutomotive from './IcoAutomotive';
import IcoAwardRibbon from './IcoAwardRibbon';
import IcoBriefcase from './IcoBriefcase';
import IcoBuildingSmall from './IcoBuildingSmall';
import IcoCalendar from './IcoCalendar';
import IcoCamera from './IcoCamera';
import IcoCheck from './IcoCheck';
import IcoChevronDown from './IcoChevronDown';
import IcoChevronLeft from './IcoChevronLeft';
import IcoChevronRight from './IcoChevronRight';
import IcoChevronUp from './IcoChevronUp';
import IcoClock from './IcoClock';
import IcoCode from './IcoCode';
import IcoCustomerServiceHeadset from './IcoCustomerServiceHeadset';
import IcoDownload from './IcoDownload';
import IcoEditPen from './IcoEditPen';
import IcoEllipseCircleHorizontal from './IcoEllipseCircleHorizontal';
import IcoEllipseCircleVertical from './IcoEllipseCircleVertical';
import IcoEllipseHorizontal from './IcoEllipseHorizontal';
import IcoEllipseVertical from './IcoEllipseVertical';
import IcoEnvelopeClosed from './IcoEnvelopeClosed';
import IcoEnvelopeOpen from './IcoEnvelopeOpen';
import IcoExpand from './IcoExpand';
import IcoExternal from './IcoExternal';
import IcoEyeHidden from './IcoEyeHidden';
import IcoEyeVisible from './IcoEyeVisible';
import IcoFile from './IcoFile';
import IcoFileAddPlus from './IcoFileAddPlus';
import IcoFileCheck from './IcoFileCheck';
import IcoFileReplaceRefresh from './IcoFileReplaceRefresh';
import IcoFileSearch from './IcoFileSearch';
import IcoFileXClose from './IcoFileXClose';
import IcoFilterSliders from './IcoFilterSliders';
import IcoFingerTap from './IcoFingerTap';
import IcoFood from './IcoFood';
import IcoForklift from './IcoForklift';
import IcoGift from './IcoGift';
import IcoGraduationCapEducation from './IcoGraduationCapEducation';
import IcoHappyFace from './IcoHappyFace';
import IcoHeart from './IcoHeart';
import IcoHeartbeat from './IcoHeartbeat';
import IcoHistory from './IcoHistory';
import IcoHome from './IcoHome';
import IcoHourglass from './IcoHourglass';
import IcoHousekeeping from './IcoHousekeeping';
import IcoInformation from './IcoInformation';
import IcoLaptopComputer from './IcoLaptopComputer';
import IcoLightbulb from './IcoLightbulb';
import IcoLightningZap from './IcoLightningZap';
import IcoLink from './IcoLink';
import IcoList from './IcoList';
import IcoListNumbers from './IcoListNumbers';
import IcoLocation from './IcoLocation';
import IcoLocationMapPin from './IcoLocationMapPin';
import IcoLock from './IcoLock';
import IcoManufacturing from './IcoManufacturing';
import IcoMedicalBenefits from './IcoMedicalBenefits';
import IcoMenuHamburger from './IcoMenuHamburger';
import IcoMerge from './IcoMerge';
import IcoMessageBubble from './IcoMessageBubble';
import IcoMovingTruck from './IcoMovingTruck';
import IcoNotificationBell from './IcoNotificationBell';
import IcoPersonalCare from './IcoPersonalCare';
import IcoPhone from './IcoPhone';
import IcoPin from './IcoPin';
import IcoPlaneSend from './IcoPlaneSend';
import IcoProfileUser from './IcoProfileUser';
import IcoProfileUserAdd from './IcoProfileUserAdd';
import IcoQuestionMark from './IcoQuestionMark';
import IcoRedo from './IcoRedo';
import IcoReplaceRefresh from './IcoReplaceRefresh';
import IcoRetail from './IcoRetail';
import IcoSadFace from './IcoSadFace';
import IcoSalaryBill from './IcoSalaryBill';
import IcoSalaryBillEnvelope from './IcoSalaryBillEnvelope';
import IcoSalaryCoin from './IcoSalaryCoin';
import IcoSaveBookmark from './IcoSaveBookmark';
import IcoSaveBookmarkFilled from './IcoSaveBookmarkFilled';
import IcoSearchMagnifyingGlass from './IcoSearchMagnifyingGlass';
import IcoSecurityShield from './IcoSecurityShield';
import IcoSettingsCog from './IcoSettingsCog';
import IcoShare from './IcoShare';
import IcoSignOut from './IcoSignOut';
import IcoSkip from './IcoSkip';
import IcoSlides from './IcoSlides';
import IcoSmartphone from './IcoSmartphone';
import IcoSparkles1 from './IcoSparkles1';
import IcoSparkles2 from './IcoSparkles2';
import IcoStar from './IcoStar';
import IcoTablet from './IcoTablet';
import IcoThumbsDown from './IcoThumbsDown';
import IcoThumbsMiddle from './IcoThumbsMiddle';
import IcoThumbsUp from './IcoThumbsUp';
import IcoTimerStopwatch from './IcoTimerStopwatch';
import IcoTourism from './IcoTourism';
import IcoTrash from './IcoTrash';
import IcoUndo from './IcoUndo';
import IcoUsersGroup from './IcoUsersGroup';
import IcoVeteranFlag from './IcoVeteranFlag';
import IcoWand from './IcoWand';
import IcoWarningCircle from './IcoWarningCircle';
import IcoWarningTriangle from './IcoWarningTriangle';
import IcoWifi from './IcoWifi';
import IcoXClose from './IcoXClose';

export { default as IcoAddPlus } from './IcoAddPlus';
export { default as IcoAlignLeft } from './IcoAlignLeft';
export { default as IcoArrowDown } from './IcoArrowDown';
export { default as IcoArrowLeft } from './IcoArrowLeft';
export { default as IcoArrowRight } from './IcoArrowRight';
export { default as IcoArrowUp } from './IcoArrowUp';
export { default as IcoAutomotive } from './IcoAutomotive';
export { default as IcoAwardRibbon } from './IcoAwardRibbon';
export { default as IcoBriefcase } from './IcoBriefcase';
export { default as IcoBuildingSmall } from './IcoBuildingSmall';
export { default as IcoCalendar } from './IcoCalendar';
export { default as IcoCamera } from './IcoCamera';
export { default as IcoCheck } from './IcoCheck';
export { default as IcoChevronDown } from './IcoChevronDown';
export { default as IcoChevronLeft } from './IcoChevronLeft';
export { default as IcoChevronRight } from './IcoChevronRight';
export { default as IcoChevronUp } from './IcoChevronUp';
export { default as IcoClock } from './IcoClock';
export { default as IcoCode } from './IcoCode';
export { default as IcoCustomerServiceHeadset } from './IcoCustomerServiceHeadset';
export { default as IcoDownload } from './IcoDownload';
export { default as IcoEditPen } from './IcoEditPen';
export { default as IcoEllipseCircleHorizontal } from './IcoEllipseCircleHorizontal';
export { default as IcoEllipseCircleVertical } from './IcoEllipseCircleVertical';
export { default as IcoEllipseHorizontal } from './IcoEllipseHorizontal';
export { default as IcoEllipseVertical } from './IcoEllipseVertical';
export { default as IcoEnvelopeClosed } from './IcoEnvelopeClosed';
export { default as IcoEnvelopeOpen } from './IcoEnvelopeOpen';
export { default as IcoExpand } from './IcoExpand';
export { default as IcoExternal } from './IcoExternal';
export { default as IcoEyeHidden } from './IcoEyeHidden';
export { default as IcoEyeVisible } from './IcoEyeVisible';
export { default as IcoFile } from './IcoFile';
export { default as IcoFileAddPlus } from './IcoFileAddPlus';
export { default as IcoFileCheck } from './IcoFileCheck';
export { default as IcoFileReplaceRefresh } from './IcoFileReplaceRefresh';
export { default as IcoFileSearch } from './IcoFileSearch';
export { default as IcoFileXClose } from './IcoFileXClose';
export { default as IcoFilterSliders } from './IcoFilterSliders';
export { default as IcoFingerTap } from './IcoFingerTap';
export { default as IcoFood } from './IcoFood';
export { default as IcoForklift } from './IcoForklift';
export { default as IcoGift } from './IcoGift';
export { default as IcoGraduationCapEducation } from './IcoGraduationCapEducation';
export { default as IcoHappyFace } from './IcoHappyFace';
export { default as IcoHeart } from './IcoHeart';
export { default as IcoHeartbeat } from './IcoHeartbeat';
export { default as IcoHistory } from './IcoHistory';
export { default as IcoHome } from './IcoHome';
export { default as IcoHourglass } from './IcoHourglass';
export { default as IcoHousekeeping } from './IcoHousekeeping';
export { default as IcoInformation } from './IcoInformation';
export { default as IcoLaptopComputer } from './IcoLaptopComputer';
export { default as IcoLightbulb } from './IcoLightbulb';
export { default as IcoLightningZap } from './IcoLightningZap';
export { default as IcoLink } from './IcoLink';
export { default as IcoList } from './IcoList';
export { default as IcoListNumbers } from './IcoListNumbers';
export { default as IcoLocation } from './IcoLocation';
export { default as IcoLocationMapPin } from './IcoLocationMapPin';
export { default as IcoLock } from './IcoLock';
export { default as IcoManufacturing } from './IcoManufacturing';
export { default as IcoMedicalBenefits } from './IcoMedicalBenefits';
export { default as IcoMenuHamburger } from './IcoMenuHamburger';
export { default as IcoMerge } from './IcoMerge';
export { default as IcoMessageBubble } from './IcoMessageBubble';
export { default as IcoMovingTruck } from './IcoMovingTruck';
export { default as IcoNotificationBell } from './IcoNotificationBell';
export { default as IcoPersonalCare } from './IcoPersonalCare';
export { default as IcoPhone } from './IcoPhone';
export { default as IcoPin } from './IcoPin';
export { default as IcoPlaneSend } from './IcoPlaneSend';
export { default as IcoProfileUser } from './IcoProfileUser';
export { default as IcoProfileUserAdd } from './IcoProfileUserAdd';
export { default as IcoQuestionMark } from './IcoQuestionMark';
export { default as IcoRedo } from './IcoRedo';
export { default as IcoReplaceRefresh } from './IcoReplaceRefresh';
export { default as IcoRetail } from './IcoRetail';
export { default as IcoSadFace } from './IcoSadFace';
export { default as IcoSalaryBill } from './IcoSalaryBill';
export { default as IcoSalaryBillEnvelope } from './IcoSalaryBillEnvelope';
export { default as IcoSalaryCoin } from './IcoSalaryCoin';
export { default as IcoSaveBookmark } from './IcoSaveBookmark';
export { default as IcoSaveBookmarkFilled } from './IcoSaveBookmarkFilled';
export { default as IcoSearchMagnifyingGlass } from './IcoSearchMagnifyingGlass';
export { default as IcoSecurityShield } from './IcoSecurityShield';
export { default as IcoSettingsCog } from './IcoSettingsCog';
export { default as IcoShare } from './IcoShare';
export { default as IcoSignOut } from './IcoSignOut';
export { default as IcoSkip } from './IcoSkip';
export { default as IcoSlides } from './IcoSlides';
export { default as IcoSmartphone } from './IcoSmartphone';
export { default as IcoSparkles1 } from './IcoSparkles1';
export { default as IcoSparkles2 } from './IcoSparkles2';
export { default as IcoStar } from './IcoStar';
export { default as IcoTablet } from './IcoTablet';
export { default as IcoThumbsDown } from './IcoThumbsDown';
export { default as IcoThumbsMiddle } from './IcoThumbsMiddle';
export { default as IcoThumbsUp } from './IcoThumbsUp';
export { default as IcoTimerStopwatch } from './IcoTimerStopwatch';
export { default as IcoTourism } from './IcoTourism';
export { default as IcoTrash } from './IcoTrash';
export { default as IcoUndo } from './IcoUndo';
export { default as IcoUsersGroup } from './IcoUsersGroup';
export { default as IcoVeteranFlag } from './IcoVeteranFlag';
export { default as IcoWand } from './IcoWand';
export { default as IcoWarningCircle } from './IcoWarningCircle';
export { default as IcoWarningTriangle } from './IcoWarningTriangle';
export { default as IcoWifi } from './IcoWifi';
export { default as IcoXClose } from './IcoXClose';

export const Icons = {
  addPlus: IcoAddPlus,
  alignLeft: IcoAlignLeft,
  arrowDown: IcoArrowDown,
  arrowLeft: IcoArrowLeft,
  arrowRight: IcoArrowRight,
  arrowUp: IcoArrowUp,
  automotive: IcoAutomotive,
  awardRibbon: IcoAwardRibbon,
  briefcase: IcoBriefcase,
  buildingSmall: IcoBuildingSmall,
  calendar: IcoCalendar,
  camera: IcoCamera,
  check: IcoCheck,
  chevronDown: IcoChevronDown,
  chevronLeft: IcoChevronLeft,
  chevronRight: IcoChevronRight,
  chevronUp: IcoChevronUp,
  clock: IcoClock,
  code: IcoCode,
  customerServiceHeadset: IcoCustomerServiceHeadset,
  download: IcoDownload,
  editPen: IcoEditPen,
  ellipseCircleHorizontal: IcoEllipseCircleHorizontal,
  ellipseCircleVertical: IcoEllipseCircleVertical,
  ellipseHorizontal: IcoEllipseHorizontal,
  ellipseVertical: IcoEllipseVertical,
  envelopeClosed: IcoEnvelopeClosed,
  envelopeOpen: IcoEnvelopeOpen,
  expand: IcoExpand,
  external: IcoExternal,
  eyeHidden: IcoEyeHidden,
  eyeVisible: IcoEyeVisible,
  file: IcoFile,
  fileAddPlus: IcoFileAddPlus,
  fileCheck: IcoFileCheck,
  fileReplaceRefresh: IcoFileReplaceRefresh,
  fileSearch: IcoFileSearch,
  fileXClose: IcoFileXClose,
  filterSliders: IcoFilterSliders,
  fingerTap: IcoFingerTap,
  food: IcoFood,
  forklift: IcoForklift,
  gift: IcoGift,
  graduationCapEducation: IcoGraduationCapEducation,
  happyFace: IcoHappyFace,
  heart: IcoHeart,
  heartbeat: IcoHeartbeat,
  history: IcoHistory,
  home: IcoHome,
  hourglass: IcoHourglass,
  housekeeping: IcoHousekeeping,
  information: IcoInformation,
  laptopComputer: IcoLaptopComputer,
  lightbulb: IcoLightbulb,
  lightningZap: IcoLightningZap,
  link: IcoLink,
  list: IcoList,
  listNumbers: IcoListNumbers,
  location: IcoLocation,
  locationMapPin: IcoLocationMapPin,
  lock: IcoLock,
  manufacturing: IcoManufacturing,
  medicalBenefits: IcoMedicalBenefits,
  menuHamburger: IcoMenuHamburger,
  merge: IcoMerge,
  messageBubble: IcoMessageBubble,
  movingTruck: IcoMovingTruck,
  notificationBell: IcoNotificationBell,
  personalCare: IcoPersonalCare,
  phone: IcoPhone,
  pin: IcoPin,
  planeSend: IcoPlaneSend,
  profileUser: IcoProfileUser,
  profileUserAdd: IcoProfileUserAdd,
  questionMark: IcoQuestionMark,
  redo: IcoRedo,
  replaceRefresh: IcoReplaceRefresh,
  retail: IcoRetail,
  sadFace: IcoSadFace,
  salaryBill: IcoSalaryBill,
  salaryBillEnvelope: IcoSalaryBillEnvelope,
  salaryCoin: IcoSalaryCoin,
  saveBookmark: IcoSaveBookmark,
  saveBookmarkFilled: IcoSaveBookmarkFilled,
  searchMagnifyingGlass: IcoSearchMagnifyingGlass,
  securityShield: IcoSecurityShield,
  settingsCog: IcoSettingsCog,
  share: IcoShare,
  signOut: IcoSignOut,
  skip: IcoSkip,
  slides: IcoSlides,
  smartphone: IcoSmartphone,
  sparkles1: IcoSparkles1,
  sparkles2: IcoSparkles2,
  star: IcoStar,
  tablet: IcoTablet,
  thumbsDown: IcoThumbsDown,
  thumbsMiddle: IcoThumbsMiddle,
  thumbsUp: IcoThumbsUp,
  timerStopwatch: IcoTimerStopwatch,
  tourism: IcoTourism,
  trash: IcoTrash,
  undo: IcoUndo,
  usersGroup: IcoUsersGroup,
  veteranFlag: IcoVeteranFlag,
  wand: IcoWand,
  warningCircle: IcoWarningCircle,
  warningTriangle: IcoWarningTriangle,
  wifi: IcoWifi,
  xClose: IcoXClose,
};

export type IconList = keyof typeof Icons;
